import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Play } from "lucide-react";
import { companyInfo, heroStats } from "../../data/mock";
import StatCounter from "../ui-custom/StatCounter";
import GlowBackdrop from "../ui-custom/GlowBackdrop";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-28 pb-20 overflow-hidden">
      <GlowBackdrop variant="hero" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="flex flex-wrap items-center gap-3 mb-8">
          {["HVDC", "FACTS", "GRID TECH"].map((chip) => (
            <span
              key={chip}
              className="glass-panel rounded-full px-4 py-1.5 text-xs font-semibold tracking-widest text-qcyan-soft"
            >
              {chip}
            </span>
          ))}
        </div>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="font-display font-bold uppercase tracking-wide text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-foreground max-w-4xl leading-[1.05]"
        >
          Powering What&rsquo;s{" "}
          <span className="glow-text-cyan">Next</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed"
        >
          {companyInfo.description}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-9 flex flex-wrap items-center gap-4"
        >
          <Link to="/power-products" className="btn-glow-primary px-7 py-3.5 rounded-md font-semibold tracking-wide inline-flex items-center gap-2">
            Explore Products <ArrowRight size={18} />
          </Link>
          <Link to="/contact" className="btn-outline-glow px-7 py-3.5 rounded-md font-semibold tracking-wide inline-flex items-center gap-2">
            Contact Us
          </Link>
          <button className="flex items-center gap-2 text-sm text-muted-foreground hover:text-qcyan transition-colors group">
            <span className="w-10 h-10 rounded-full border border-qcyan/40 flex items-center justify-center group-hover:shadow-[0_0_20px_rgba(255, 0, 15,0.5)] transition-shadow">
              <Play size={14} className="fill-qcyan text-qcyan ml-0.5" />
            </span>
            Watch Company Film
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 max-w-4xl"
        >
          {heroStats.map((stat, i) => (
            <StatCounter
              key={stat.label}
              value={stat.value}
              suffix={stat.suffix}
              label={stat.label}
              glow={i % 2 === 0 ? "cyan" : "amber"}
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
